import { fetchPdfss } from './fetchPdf'
import { fetchAttachedImages } from './fetchImage'
import { fetchSignaturess } from './fetchSignature'

export class AttachedResources {
  /**
   * @param {ImageBase64WithDimensions[][]} imgsWithDimensions 
   * @param {Signatures[]} signatures 
   * @param {ArrayBuffer[][]} pdfs
   */
  constructor (imgsWithDimensions, signatures, pdfs) {
    this.imgsWithDimensions = imgsWithDimensions
    this.signatures = signatures
    this.pdfs = pdfs
  }
}

/**
 * @param {import('../constructionLog').ConstructionLog} constructionLog
 * @return {Promise<AttachedResources>}
 */
export const fetchAttachedResources = constructionLog =>
  Promise.all([
    fetchAttachedImages(constructionLog),
    fetchSignaturess(constructionLog),
    fetchPdfss(constructionLog)])
    .then(arr => new Promise(
      resolve => resolve(new AttachedResources(arr[0], arr[1], arr[2]))
    ))